import { Text } from "@assetwatch/ui";
import type { AskReliDisplayMessage } from "../AskReli.types";

type AskReliVisualization = NonNullable<AskReliDisplayMessage["visualization"]>;

export function AskReliVisualizationBarChart({
  visualization,
}: {
  visualization: AskReliVisualization;
}) {
  const maxValue = Math.max(
    ...visualization.points.map((point) => point.value),
    1,
  );

  return (
    <section
      data-testid="ask-reli-bar-chart"
      aria-label={visualization.title}
      className="w-full max-w-[620px] rounded-(--radius-lg) border border-outline-subtle bg-surface-container-high/[0.35] px-(--spacing-12) py-(--spacing-10)"
    >
      <div className="mb-(--spacing-8) font-(number:--font-weight-semibold)">
        <Text size="sm" as="div">
          {visualization.title}
        </Text>
      </div>
      {visualization.yLabel ? (
        <div className="mb-(--spacing-8)">
          <Text size="sm" tone="subtle" as="div">
            {visualization.yLabel}
          </Text>
        </div>
      ) : null}
      <div className="flex flex-col gap-(--spacing-6)">
        {visualization.points.map((point) => (
          <div
            className="grid grid-cols-[minmax(90px,160px)_minmax(0,1fr)_auto] items-center gap-(--spacing-8)"
            key={`${point.label}-${point.value}`}
          >
            <div
              className="overflow-hidden text-ellipsis whitespace-nowrap text-(length:--font-size-label-sm) text-text-subtle"
              title={point.label}
            >
              {point.label}
            </div>
            <div className="h-(--spacing-12) w-full overflow-hidden rounded-full bg-surface-container-high/[0.7]">
              <div
                className="h-full rounded-full bg-primary"
                style={{
                  width: `${Math.max((point.value / maxValue) * 100, 6)}%`,
                }}
              />
            </div>
            <div className="text-(length:--font-size-label-sm) font-(number:--font-weight-semibold)">
              {point.value.toLocaleString()}
            </div>
          </div>
        ))}
      </div>
      {visualization.xLabel ? (
        <div className="mt-(--spacing-8)">
          <Text size="sm" tone="subtle" as="div">
            {visualization.xLabel}
          </Text>
        </div>
      ) : null}
    </section>
  );
}
